import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TTableFilter } from '@interfaces/components/table';

import { EVendorsValues } from '@enums/common';

import { MIN_FILTER_WIDTH } from '@constants/common';
import { TableFilterTypes } from '@constants/table';
import {
	ALARMS_FLEXIDAS_SEARCH_PLACEHOLDER,
	ALARMS_ORAN_SEARCH_PLACEHOLDER,
	ALARMS_ORAN_SEARCH_PLACEHOLDER_HISTORY,
	ALARMS_SEARCH_PLACEHOLDER,
} from '../constants';

export const generateAlarmsFilters = (
	options: IAlarmFilter[],
	selectedFilters: Record<string, TSelectOption>,
	setSelectedGeneratedFilters: (value: Record<string, TSelectOption>) => void,
): TTableFilter[] => {
	return options.map((filter) => {
		return !filter?.type || filter?.type === TableFilterTypes.SELECT ? {
			type: TableFilterTypes.SELECT,
			name: filter.name,
			placeholder: filter.placeholder,
			option: selectedFilters[filter.name] || null,
			options: filter.data,
			minWidth: MIN_FILTER_WIDTH,
			setState: (option: TSelectOption<string>) => {
				setSelectedGeneratedFilters({ [filter.name]: option?.name ? option : null });
			},
			defaultValue: null,
		} : {
			type: TableFilterTypes.MULTISELECT,
			name: filter.name,
			placeholder: filter.placeholder,
			option: selectedFilters[filter.name] || null,
			options: filter.data,
			minWidth: MIN_FILTER_WIDTH,
			setState: (option: TSelectOption<string>[] | null) => {
				setSelectedGeneratedFilters({ [filter.name]: option as TSelectOption<string> });
			},
			defaultValue: [],
		};
	});
};

export const getSearchTooltip = (vendor: string, isActiveAlarmsTab: boolean) => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return ALARMS_FLEXIDAS_SEARCH_PLACEHOLDER;
		case EVendorsValues.oran:
			return isActiveAlarmsTab
				? ALARMS_ORAN_SEARCH_PLACEHOLDER
				: ALARMS_ORAN_SEARCH_PLACEHOLDER_HISTORY;
		case EVendorsValues.limenet:
			return ALARMS_SEARCH_PLACEHOLDER;
	}
};
